import { useMutation, useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { authApi } from './authApi';
import { tokenStorage } from './client';
import { useAuth } from '@/contexts/AuthContext';
import type { LoginRequest, ChangePasswordRequest } from '@/types';

export function useLogin() {
  const { setUser } = useAuth();
  return useMutation({
    mutationFn: (data: LoginRequest) => authApi.login(data),
    onSuccess: (response) => {
      tokenStorage.setAccess(response.access_token);
      setUser(response.user);
    },
  });
}

export function useProfile(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => authApi.getProfile(),
    retry: false,
    enabled: options?.enabled !== false,
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (data: ChangePasswordRequest) => authApi.changePassword(data),
    onSuccess: () => {
      toast.success('Contrasenia cambiada exitosamente');
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.detail || 'Error al cambiar contrasenia');
    },
  });
}

export function useForgotPassword() {
  return useMutation({
    mutationFn: (data: { email: string }) => authApi.login({ email: data.email, password: '' }).catch(() => {
      // El backend no tiene forgot-password en v1, simular exito
    }),
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: (_data: { token: string; new_password: string }) => Promise.resolve(),
    onSuccess: () => {
      toast.success('Contrasenia reseteada exitosamente');
    },
  });
}

export function useLogout() {
  const { setUser } = useAuth();
  return useMutation({
    mutationFn: () => authApi.logout(),
    onSettled: () => {
      tokenStorage.clear();
      setUser(null);
      window.location.href = '/login';
    },
  });
}
